export default __webpack_public_path__ + "static/media/CustomManageCompanyProfile.cea67796.png";